var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRebalanceArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01056 12.4364C10.3298 11.0909 10.3298 8.9091 9.01056 7.5636L2.40373 0.827526C1.95804 0.373123 1.22614 0.373152 0.780495 0.827589C0.346986 1.26965 0.346959 1.97733 0.780433 2.41943L7.41732 9.18826C7.8569 9.63671 7.85684 10.3633 7.41732 10.8117L0.780434 17.5806C0.34696 18.0227 0.346986 18.7304 0.780495 19.1724C1.22614 19.6268 1.95804 19.6269 2.40373 19.1725L9.01056 12.4364Z",
    fill: "#151515",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0106 12.4364C20.3298 11.0909 20.3298 8.9091 19.0106 7.5636L12.4037 0.827526C11.958 0.373123 11.2261 0.373152 10.7805 0.827589C10.347 1.26965 10.347 1.97733 10.7804 2.41943L17.4173 9.18826C17.8569 9.63671 17.8568 10.3633 17.4173 10.8117L10.7804 17.5806C10.347 18.0227 10.347 18.7304 10.7805 19.1724C11.2261 19.6268 11.958 19.6269 12.4037 19.1725L19.0106 12.4364Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebalanceArrows);
export default __webpack_public_path__ + "static/media/rebalance-arrows.2526021ab5f9ecf1317e0184ede7bd13.svg";
export { ForwardRef as ReactComponent };